var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('wx-open-launch-weapp',{attrs:{"username":"gh_96d43fcb44bf","path":"/pages/hvac/member/auth"}},[_c('script',{attrs:{"type":"text/wxtag-template"}},[_vm._v(" <div>打开小程序1</div> ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }